'use client';

import { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider as ReduxProvider } from 'react-redux';
import { useParams } from 'next/navigation';
import { sdk } from 'sdk';
import { rootStore } from 'store';
import { useDataDogLogging } from 'frontastic/hooks';
import { AuthenticationProvider } from './authentication';
import { SWRProvider } from './swr';

export const Providers = ({ children }: PropsWithChildren) => {
  const { locale } = useParams();
  useDataDogLogging();

  sdk.configureForNext(locale);

  return (
    <IntlProvider locale="en">
      <ReduxProvider store={rootStore}>
        <SWRProvider value={{ fallback: {} }}>
          <AuthenticationProvider locale={locale}>
            {children}
          </AuthenticationProvider>
        </SWRProvider>
      </ReduxProvider>
    </IntlProvider>
  );
};
